export enum PEOPLE_PAGE_ANCHOR {
  PEOPLE_TABLE = 'people-table',
  GENDER_TABLE = 'gender-table',
  RACE_TABLE = 'race-table',
  AGE_TABLE = 'age-table',
  LOCATION_TABLE = 'location-table',
}
